import React, { useState, useEffect, Fragment } from "react";

import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import {
  setChecklinkHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
  setManageDealerID,
} from "../../../actions/headerMenu/headerMenu";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spin, Table, Tooltip } from "antd";
import AppsColorStoneLinksService from "../../../services/apps-colorstonelinks.service";

export const ManageGemStoneVendor = (props) => {
  const { t } = useTranslation();
  const [loadingProfileData, setLoadingProfileData] = useState(false);
  const [saveLoadingProfileData, setSaveLoadingProfileData] = useState(false);
  const [rowDetails, setRowDetails] = useState({});
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [dealerId, setDealerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [commVendorData, setCommVendorData] = useState([]);
  const [diamondRapNetPermissionData, setDiamondRapNetPermission] = useState(
    []
  );

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [checkBool, setCheckBool] = useState(null);
  const [mainCheckVal, setMainCheckVal] = useState(false);
  const [diamondCount, setDiamondCount] = useState({});
  const [disabledbtn, setDisabledbtn] = useState(true);
  const [boolCount, setBoolCount] = useState(0);
  const [sortColumnName, setSortColumnName] = useState("DealerID");
  const [sortType, setSortType] = useState("asc");
  const [search, setSearch] = useState([]);
  const [confirmPopUp, setConfirmPopUp] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedCheckboxData, setSelectedCheckboxData] = useState(null);
  const [confirmPopUpForAll, setConfirmPopUpForAll] = useState(false);
  const [selectedAllCheckboxData, setSelectedAllCheckboxData] = useState(null);

  const loginDetials = useSelector((state) => state.loginReducer);
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleBindDataCommVendor(
            loginDetials.loginDetials.responseData.dealerId,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            search
          );
        }
      }
    }
  }, []);

  const handleBindDataCommVendor = (
    id,
    pageNo,
    pageSize,
    sortColumnName,
    sortOrder,
    search
  ) => {
    try {
      let inputData = {
        dealerID: id.toString(),
        moduleName: "GemStoneLink",
      };
      setLoading(true);
      AppsColorStoneLinksService
        .BindDealerList(inputData, "GemStoneLink")
        .then((response) => {
          let message = response.data.message;
          
          let responseData = response.data.responseData.dealerlist;
          let diamondCount = response.data.responseData.dimaondcount;          
          if (message === "Success") {
            if (checkBool !== null) {
              if (checkBool == true) {
                let tempcommVendorData = responseData;
                tempcommVendorData.forEach((element) => {
                  element.selectedDealerID = 1;
                });
                setCommVendorData(tempcommVendorData);
                setDiamondCount(diamondCount);
              } else if (!checkBool && boolCount == 1) {
                setCommVendorData(responseData);
                setDiamondCount(diamondCount);
              } else {
                let tempcommVendorData = responseData;
                tempcommVendorData.forEach((element) => {
                  element.selectedDealerID = 0;
                });
                setCommVendorData(tempcommVendorData);
                setDiamondCount(diamondCount);
              }
            } else {
              setCommVendorData(responseData);
              const temp = responseData;
              const testBoolean = temp.every((m) => {
                if (m.selectedDealerID == 0) {
                  return false;
                }
                return true;
              });
              setMainCheckVal(testBoolean);
              setDiamondCount(diamondCount);
            }

            setLoading(false);
            setBoolCount(1);
          } else {
            setCommVendorData([]);

            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // Confirmation Popup Start
  const handleOpenConfirmation = (row, e, name) => {
    setConfirmPopUp(true);
    setSelectedCheckboxData({
      row,
      e,
      name,
    });
  };

  const handleCancelConfirmation = () => {
    setConfirmPopUp(false);
  };
  const handleCancelConfirmationForAll = () => {
    setConfirmPopUpForAll(false);
  };

  const handleConfirmConfirmation = () => {
    if (selectedCheckboxData) {
      handleOnChange(
        selectedCheckboxData.row,
        selectedCheckboxData.e,
        selectedCheckboxData.name
      );
    }
    setConfirmPopUp(false);
  };
  const handleConfirmConfirmationForAll = () => {
    handleOnCheckGridAll(selectedAllCheckboxData);
    setConfirmPopUpForAll(false);
  };

  // Confirmation Popup End

  const handleOnChange = (row, e, name) => {
    setDisabledbtn(false);
    if (name === "selectedDealerID") {
      const temp = commVendorData.map((x) => {
        if (x.dealerID == row.dealerID) {
          return {
            ...x,
            selectedDealerID: e.target.checked == true ? 1 : 0, // Remove ! from here if you change onchange from table checkbox
          };
        } else return x;
      });

      setCommVendorData(temp);
      setDiamondRapNetPermission(temp);

      const testBoolean = temp.every((m) => {
        if (m.selectedDealerID == 0) {
          return false;
        }
        return true;
      });
      setMainCheckVal(testBoolean);
      setCheckBool(testBoolean);
    }
  };

  const handleOnCheckGridAll = (e) => {
    setDisabledbtn(false);
    setCheckBool(e);
    setMainCheckVal(e);
    let tempcommVendorData = commVendorData;
    tempcommVendorData.forEach((element) => {
      element.selectedDealerID = e ? 1 : 0;
    });
    setCommVendorData([...tempcommVendorData]);
    setDiamondRapNetPermission([...tempcommVendorData]);
  };

  const handleShowDataToRightNew = (record) => {
    try {
      let inputData = {
        vendorID: record.dealerID.toString(),
        f_Type: "",
        dealerID: dealerId.toString(),
      };
      setSelectedColumnId(record.dealerID);
      setLoadingProfileData(true);
      AppsColorStoneLinksService
        .ShowDataToRightNew(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData[0];
          //debugger;
          if (message === "Success") {
            if (responseData) {
              setRowDetails(responseData);
              setLoadingProfileData(false);
            } else {
              setRowDetails({});
              setLoadingProfileData(false);
            }
          } else {
            setRowDetails({});
            setLoadingProfileData(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setLoadingProfileData(false);
        });
    } catch (error) {
      console.log(error);
      setLoadingProfileData(false);
    }
  };

  const handleSaveSelect = () => {
    try {
      let selectedList = diamondRapNetPermissionData
        .filter(function (item) {
          return item.selectedDealerID == 1;
        })
        .map(function (item) {
          return item.dealerID;
        });
      let inputData = {
        dealerID: dealerId.toString(),
        listDealerID: selectedList,
        moduleName:"DiamondLink",
      };
      setSaveLoadingProfileData(true);
      AppsColorStoneLinksService
        .UpdateListClick(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          if (message === "Success") {
            NotificationManager.success(t("Updated Successfully."));
            handleBindDataCommVendor(
              dealerId,
              pageNo,
              pageSize,
              sortColumnName,
              sortType,
              search
            );
            setSaveLoadingProfileData(false);
            setDisabledbtn(true);
          } else {
            NotificationManager.error(t("Not Updated."));
            setSaveLoadingProfileData(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setSaveLoadingProfileData(false);
        });
    } catch (error) {
      console.log(error);
      setSaveLoadingProfileData(false);
    }
  };

  const handleOnVendorNameClick = (dealerID) => {
    navigate(`/applicationPreviewDiamondLink`);
  };

  const columns = [
    {
      title: <Tooltip title={t("Vendor Name")}>{t("Vendor Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "dealerCompany",
      width: "230px",
      showSorterTooltip: false,
      sorter: (a, b) => a.dealerCompany.localeCompare(b.dealerCompany),
      render: (item, row) => {
        return (
          <span
            className="linkText"
          >
            {row.dealerCompany}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip title={t("Gem Stones")}>{t("Gem Stones")}</Tooltip>
      ),
      ellipsis: true,
      dataIndex: "mindCount",
      showSorterTooltip: false,
      sorter: (a, b) => a.mindCount - b.mindCount,
    },
    
    {
      title: <Tooltip title={t("Updated")}>{t("Updated")}</Tooltip>,
      ellipsis: true,
      dataIndex: "modified",
      showSorterTooltip: false,
      sorter: (a, b) => a.modified.localeCompare(b.modified),
    },
    {
      title: (
        <div className="filtbtn__div">
          <label className="table__label">
            <i className="fa fa-eye" aria-hidden="true"></i>
          </label>
          <span className="select__all">
            <input
              type="checkbox"
              id="sel"
              onChange={(e) => {
                // handleOnCheckGridAll(e.target.checked)
                setSelectedAllCheckboxData(e.target.checked);
                setConfirmPopUpForAll(true);
              }}
              checked={mainCheckVal}
            />
          </span>
        </div>
      ),
      dataIndex: "selectedDealerID",
      render: (item, row) => {
        return (
          <div className="action__btns">
            <input
              type="checkbox"
              name="selectedDealerID"
              checkedChildren={t("Yes")}
              unCheckedChildren={t("No")}
              checked={row.selectedDealerID == 1 ? true : false}
              onChange={(e) => {
                setIsChecked(row.selectedDealerID == 1);
                //handleOpenConfirmation(row, e, "selectedDealerID");
                handleOnChange(row, e, "selectedDealerID");
              }}
            />
          </div>
        );
      },
    },
  ];

  const dispatch = useDispatch();
  let navigate = useNavigate();

  const handleHeaderMenuClickForSideProfileApp = (type) => {
    if (type == "Profile") {
      navigate("/dealerProfile", {
        state: {
          key: "Profile",
          id: selectedColumnId,
          pageType:
            props.type == "Diamond Vendor" ? "RingBuilder" : "DiamondLink",
        },
      });
    } else if (type == "Conversation") {
      navigate("/dealerProfile", {
        state: {
          key: "Conversation",
          id: selectedColumnId,
          pageType:
            props.type == "Diamond Vendor" ? "RingBuilder" : "DiamondLink",
        },
      });
    } else if (type == "Inventory") {
      // here
      // debugger;
      console.log('rowDetails: ' + rowDetails);
      console.log('commVendorData: ' + commVendorData);


      dispatch(setChecklinkHeaderMenuData("My Catalog"));
      let MenuData = [`${"Products"}`, `${"ProductsDiamond"}`];
      dispatch(setOpenKeyHeaderMenuData(MenuData));
      dispatch(setSelectSideMenu(["viewMyMinedDiamond"]));
      //  dispatch(setManageDealerID(rowDetails.dealerID));
      // debugger;
      let selectedData = commVendorData.filter(function (item) {
        return item.dealerID == rowDetails.dealerID;
      });

      if (selectedData.length > 0) {
        const { color, mindCount, labTotalCount } = selectedData[0];

        // Convert to numbers in case they’re strings
        const colorCount = Number(color) || 0;
        const minedCount = Number(mindCount) || 0;
        const labCount = Number(labTotalCount) || 0;

        // Find the maximum value
        const maxCount = Math.max(colorCount, minedCount, labCount);

        let redirectPath = "/diamondSearch"; // default

        if (maxCount === 0 || (colorCount === minedCount && minedCount === labCount)) {
          redirectPath = "/diamondSearch";
        } else if (maxCount === colorCount) {
          redirectPath = "/colorDiamondSearch";
        } else if (maxCount === labCount) {
          redirectPath = "/labDiamondSearch";
        } else if (maxCount === minedCount) {
          redirectPath = "/diamondSearch";
        }

        navigate(redirectPath, {
          state: {
            id: selectedColumnId,
          },
        });
      }

    }
  };

  const openInNewTab = (websiteAddress) => {
    if (websiteAddress.includes("https")) {
      window.open(websiteAddress, "_blank");
    } else if (websiteAddress.includes("http")) {
      window.open(websiteAddress, "_blank");
    } else if (websiteAddress.includes("WWW")) {
      window.open("https://" + websiteAddress, "_blank");
    } else {
      window.open("https://" + websiteAddress, "_blank");
    }
  };

  return (
    <div className="form__fields">
      <div className="row magento__mapping permission__section">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 className="workarea__heading mt-0 mb-0">
              {" "}
              {props.type ? t("Diamond Vendors") : t("Manage Vendor")}{" "}
            </h4>
          </div>
        </div>
        <div className="col-lg-9 divForm vendors-section">
          <Spin spinning={loading}>
            <Table
              columns={columns}
              dataSource={commVendorData}
              rowKey={(record) => record.dealerID}
              pagination={{
                size: "small",
                defaultPageSize: 20,
                pageSizeOptions: [20, 50, 100],
                responsive: true,
                showSizeChanger: true,
              }}
              onRow={(record, recordIndex) => ({
                onClick: (event) => {
                  handleShowDataToRightNew(record);
                },
              })}
            />
          </Spin>
        </div>

        <div className="col-lg-3 col-md-3">
          <Spin spinning={loadingProfileData}>
            <div className="right__section">
              {selectedColumnId !== 0 ? (
                <Fragment>
                  <div className="profile__block">
                    <span
                      onClick={() =>
                        handleHeaderMenuClickForSideProfileApp("Profile")
                      }
                      className="linkText"
                    >
                      {rowDetails.designerName ? rowDetails.designerName : null}
                    </span>
                    <div className="logoImg__block p-0">
                      <img src={rowDetails.src ? rowDetails.src : null} />
                    </div>
                  </div>

                  <div className="retailer__dtls mb-4">
                    <p>
                      {" "}
                      {rowDetails.dealerName
                        ? rowDetails.dealerName
                        : null}{" "}
                    </p>
                    <a href={`mailto:${rowDetails.dealerEmail}`}>
                      {" "}
                      {rowDetails.dealerEmail
                        ? rowDetails.dealerEmail
                        : null}{" "}
                    </a>
                    <a
                      onClick={() =>
                        openInNewTab(
                          rowDetails.website ? rowDetails.website : null
                        )
                      }
                    >
                      {rowDetails.website ? rowDetails.website : null}
                    </a>
                    <p>
                      {" "}
                      {rowDetails.dealerPhone
                        ? rowDetails.dealerPhone
                        : null}{" "}
                    </p>

                    <hr />
                  </div>
                  <div className="links__block">
                    <ul>
                      <li>
                        <span
                          onClick={() =>
                            handleHeaderMenuClickForSideProfileApp("Profile")
                          }
                          className="linkText"
                        >
                          <i
                            className="fa fa-address-book-o"
                            aria-hidden="true"
                          ></i>{" "}
                          {t("View Profile")}
                        </span>
                      </li>
                      <li>
                        <span
                          onClick={() =>
                            handleHeaderMenuClickForSideProfileApp(
                              "Conversation"
                            )
                          }
                          className="linkText"
                        >
                          <i
                            className="fa fa-comments-o"
                            aria-hidden="true"
                          ></i>{" "}
                          {t("Conversation")}
                        </span>
                      </li>
                      <li>
                        <span
                          onClick={() =>
                            handleHeaderMenuClickForSideProfileApp("Inventory")
                          }
                          className="linkText"
                        >
                          <i className="fa fa-diamond" aria-hidden="true"></i>{" "}
                          {t("View Inventory")}
                        </span>
                      </li>
                    </ul>
                    <hr />
                  </div>
                </Fragment>
              ) : (
                <div className="retailer__dtls mb-4">
                  <p>{t("Total Gem Stones")}</p>
                  <span>{diamondCount.totalMindCount}</span>

                  {/* <hr />

                  <p>{t("Total LabGrown Diamonds")}</p>
                  <span>{diamondCount.totalLabTotalCount}</span>

                  <hr />
                  <p>{t("Total Color Diamonds")}</p>
                  <span>{diamondCount.totalColor}</span> */}
                </div>
              )}
              <div className="input__block">
                <button
                  disabled={disabledbtn}
                  className={disabledbtn ? "disabled-btn" : "primary-btn"}
                  onClick={handleSaveSelect}
                  loading={saveLoadingProfileData}
                >
                  {" "}
                  {t("Update List")}{" "}
                </button>
              </div>
            </div>
          </Spin>
        </div>
      </div>
      {/* Confirmation Modal */}

      <Modal
        title={t("Please Confirm")}
        className="datamapping__modal"
        width={400}
        centered
        visible={confirmPopUp}
        onCancel={handleCancelConfirmation}
        maskClosable={false}
        footer={[
          <Button onClick={handleCancelConfirmation}>{t("No")}</Button>,

          <Button type="primary" onClick={handleConfirmConfirmation}>
            {t("Yes")}
          </Button>,
        ]}
      >
        <div className="form__fields row border-0 p-0">
          <div className="col-lg-12 text-center">
            <p>
              {" "}
              <>
                {t("Do you want to")}{" "}
                {!isChecked ? t("connect") : t("disconnect")}{" "}
                {t("Vendor GemStone?")}
              </>
            </p>
          </div>
        </div>
      </Modal>
      <Modal
        title={t("Please Confirm")}
        className="datamapping__modal"
        width={400}
        centered
        visible={confirmPopUpForAll}
        onCancel={handleCancelConfirmationForAll}
        maskClosable={false}
        footer={[
          <Button onClick={handleCancelConfirmationForAll}>{t("No")}</Button>,
          <Button type="primary" onClick={handleConfirmConfirmationForAll}>
            {t("Yes")}
          </Button>,
        ]}
      >
        <div className="form__fields row border-0 p-0">
          <div className="col-lg-12 text-center">
            <p>
              {t("Do you want to")}
              {!mainCheckVal ? t("connect") : t("disconnect")}
              {t("All Vendor GemStone?")}`
            </p>
          </div>
        </div>
      </Modal>

      {/* End Confirmation Modal */}
    </div>
  );
};

export default ManageGemStoneVendor;
